var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusSuccessType2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.0957,
    height: 64.0957,
    rx: 32.0478,
    fill: "#58A618"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2726 17.6763C46.9635 16.9171 48.1187 16.8009 48.9458 17.4393C49.7728 18.0778 49.9786 19.2445 49.4517 20.1301L49.3357 20.3032L30.8357 45.2846C29.2045 47.4871 26.0325 47.6836 24.1526 45.6987L14.2512 35.243L14.1156 35.0859C13.4872 34.2718 13.5527 33.0873 14.2982 32.3512C15.0436 31.6153 16.2047 31.5885 16.9805 32.2567L17.1305 32.4005L27.0319 42.8548C27.2028 43.0352 27.4912 43.0177 27.6395 42.8175L46.1409 17.8374L46.2726 17.6763Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccessType2);
export default __webpack_public_path__ + "static/media/status_success_type_2.1700dfb673e810231bec4492eac1f5bd.svg";
export { ForwardRef as ReactComponent };